<script>
	import { createEventDispatcher } from "svelte";
	import {flip} from 'svelte/animate';

	export const dispatch = createEventDispatcher();

	// export let id;
	export let blockid;
	export let text;
	export let complete;
	export let url;
	export let size;
	export let permissions;
	export let order;

	let menuVisible = true;

	function remove() {
		dispatch("remove", { blockid });
	}

	function toggleStatus() {
		let newStatus = !complete;
		dispatch("toggle", {
			block,
			newStatus,
		});
	}

	function toggleSize(newSize) {
		// let newStatus = !complete;
		size = newSize;
		// console.log("new size: " + newSize)
		// size = size;
		dispatch("toggle", {
			blockid,
			newSize,
		});
	}

	function toggleMenu(){
		if(permissions ==  "true"){
			menuVisible = !menuVisible;
		}
	}


</script>


<div data-order="{order}" class="block {size}" id={blockid} class:hoverable={permissions=="true"} >
	{#if complete}
		<span class="is-complete">{text}</span>
		<button on:click={toggleStatus}> ✔️ </button>
	{:else}
		{#if url}
			<!-- <p>{order}</p> -->
			<div class="fit-parent">
				<img src="{url}" alt="">
			</div>
		{/if}
		<div class="absolute-full" on:click|self={toggleMenu}>
			<!-- <p>{text}</p> -->
			<!-- <p>{id}</p> -->
			<!-- <p>block id: {blockid}</p> -->
		</div>

		<div class="menu-size" class:hidden={menuVisible}>
			<div class="options-section">
				<button on:click={remove} id="closeMenu">X</button>
				<!-- <div class="color-options">
					<input type="color" id="head" name="head" value="#e66465">
					
				</div> -->
				<div id="resizeOptions" class="menu-size-options" on:click={toggleMenu}>
					<div data-class="_1x1" class="_1by1" on:click={()=>toggleSize("_1x1")} ></div>
					<div data-class="_1x2" class="_1by2" on:click={()=>toggleSize("_1x2")} ></div>
					<div data-class="_1x3" class="_1by3" on:click={()=>toggleSize("_1x3")} ></div>
					<div data-class="_2x1" class="_2by1" on:click={()=>toggleSize("_2x1")} ></div>
					<div data-class="_2x2" class="_2by2" on:click={()=>toggleSize("_2x2")} ></div>
				</div>
				<div class="menu-size-options" on:click={toggleMenu}>
					<div data-class="_2x3" class="_2by3" on:click={()=>toggleSize("_2x3")} ></div>
					<div data-class="_3x1" class="_3by1" on:click={()=>toggleSize("_3x1")} ></div>
					<div data-class="_3x2" class="_3by2" on:click={()=>toggleSize("_3x2")} ></div>
					<div data-class="_3x3" class="_3by3" on:click={()=>toggleSize("_3x3")} ></div>
				</div>
			</div>
			<!-- <button on:click={toggleStatus}> ❌ </button> -->
			<!-- <button on:click={remove}> 🗑 </button> -->
		</div>
		
	{/if}

</div>

<style>
	.menu-size{
		width: auto !important;
	}
	.is-complete {
		text-decoration: line-through;
		color: green;
	}

	.menu-size{
		position: absolute;
		top: 2px;
		left: 2px;
	}

</style>
